import { initializeApp, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; 
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFirestore, connectFirestoreEmulator, initializeFirestore, memoryLocalCache } from 'firebase/firestore';
import './firebase'; // guarantee the portal (default) app is initialised first

import { isLocal } from './config';

const prmassist1Config = {
  apiKey: "AIzaSyBOhBofqRiwCbpK_kTF5EDThlnK5vPSr_0",
  authDomain: "prmassist1.firebaseapp.com",
  projectId: "prmassist1",
  storageBucket: "prmassist1.appspot.com",
  messagingSenderId: "32133056836",
  appId: "1:32133056836:web:65baa422ce6d91802a2f11",
  measurementId: "G-PP85ELBZHY"
};

let app;
let firestore;
let storage;

if (isLocal) {
  // Reuse the portal (default) app — firebase.js already initialised it
  // and connected Auth, Firestore & Storage to the emulators.
  app = getApp();
  firestore = getFirestore(app);
  storage = getStorage(app);
  console.log('Localhost detected — secondary Firestore reusing portal (default) app for emulator');
} else {
  try {
    firebase.initializeApp(prmassist1Config, "secondary");
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

  app = initializeApp(prmassist1Config, "secondary");
  firestore = initializeFirestore(app, {
    localCache: memoryLocalCache(),
  });
  storage = getStorage(app);
  try {
    getAnalytics(app);
  } catch (e) {
    if (!/already exists/.test(e.message)) throw e;
  }
}

const fire = firebase;
export default fire;
export { app, firestore, storage };
